import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared-module/shared.module';
import { PlaybookService } from './playbook.service';
import { ROUTES } from './playbook.routes';
import { PlaybookComponent } from './playbook.component';
import { PlayBookCartComponent } from './playbook-cart/playbook-cart.component';


@NgModule({ 
  imports: [
  CommonModule,
  RouterModule.forChild(ROUTES),
  SharedModule
],
  declarations: [
    PlayBookCartComponent,
    PlaybookComponent],
 
  providers: [PlaybookService]
})
export class PlaybookModule{ }
